import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=f8fad4f0&scoped=true&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=f8fad4f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fad4f0",
  null
  
)

export default component.exports